/**************
 Cart
 ***************/

// free ring sizer variant id
const freeRingSizerVariantID = 43470089289911;

// open cart
async function openCart(skipFetch = false, showWarning = false) {
    // open cart if not already open
    if (document.querySelector("#miniCart:not([open])")) {
        document.querySelector("#miniCart").showModal();
    }
    document.querySelector("body").classList.add("noScroll");

    // reset container
    // document.querySelector("#miniCartBody").innerHTML = "";

    // start loading animation
    document.querySelector("#miniCartContent").classList.add("loading");

    // hide empty cart section
    document.querySelector("#miniCartEmpty").classList.remove("active");

    // fetch cart
    if (skipFetch === false) {
        cart = await getCart();
    }

    /****************** FREE RING SIZER ******************/

        // they get 1 free ring sizer if they have a line item with "I don't know my size"
    let correctQuantity = cart.items.some(item => item.variant_options.includes("I don't know my size")) ? 1 : 0

    // current quantity of free gift
    let currentQuantity = 0;
    let freeGiftItem = cart.items.find(item => item.variant_id === freeRingSizerVariantID);
    if (freeGiftItem) {
        currentQuantity = freeGiftItem.quantity;
    }

    // if they have a subscription, and don't have the free gift, we add the free gift
    if (correctQuantity > 0 && currentQuantity === 0) {
        await addProduct({
            items: [{
                quantity: correctQuantity,
                id: freeRingSizerVariantID,
            }]
        });
        await openCart();
        return;
    }
    // otherwise we update it to the correct quantity
    else if (correctQuantity !== currentQuantity) {
        cart = await updateCart({
            updates: {
                [freeGiftItem.key]: correctQuantity
            }
        });
        await openCart(true);
        return;
    }

    // get cart item data
    let cartData = await fetch("/cart?view=supplemental-data")
        .then(response => response.json());
    let variantIDToCompareAtPrice = cartData.variantIDToCompareAtPrice;
    let variantIDToInventory = cartData.variantIDToInventory;
    let variantIDToUnbridaled = cartData.variantIDToUnbridaled;

    // check IMS inventory for each cart item
    // don't allow to buy more than allowed
    let updatePayload = {};
    for (const item of cart.items) {
        // unbridaled products are not stocked in our IMS, so skip them
        // the diamonds the app creates are their own untagged products, so also skip anything
        // carrying the _grouping property it stamps on every line item it adds
        if (variantIDToUnbridaled[item.variant_id] || item.properties?._grouping) {
            continue;
        }

        let inventoryStatus = await getInventoryStatus(item.sku);

        // if error, remove item
        if (inventoryStatus.error) {
            updatePayload[item.key] = 0;
        }

        // if item quantity is greater than on hand inventory AND we shoudl stop selling when out of stock
        if (inventoryStatus.stop_selling_when_out_of_stock && inventoryStatus.on_hand_minus_committed_inventory < item.quantity) {
            // only allow up to the max available quantity
            updatePayload[item.key] = inventoryStatus.on_hand_minus_committed_inventory;
        }
    }

    // if update payload isn't empty, update
    if (Object.keys(updatePayload).length > 0) {
        await updateCart({updates: updatePayload});
        await openCart(false, true);
        return;
    }

    if (showWarning) {
        // show message that their cart needed to be updated
        // target the miniCart dialog so Swal renders inside the top-layer context
        await Swal.fire({
            title: "Inventory Out of Stock",
            text: "One or more items in your cart are out of stock and have been updated based on current availability.",
            target: document.querySelector("#miniCart"),
            customClass: {
                popup: "maltertechSwal",
            },
        });
    }

    /****************** END FREE RING SIZER ******************/

    // stop loading animation
    document.querySelector("#miniCartContent").classList.remove("loading");


    // keep the mobile menu's bag count in step with the cart
    document.querySelector("#sliderLinksBagCount").textContent = cart.item_count;

    // rebuild the upsells against the current cart, it owns its own visibility so we never await it
    renderUpsells();

    // update active body
    if (cart.item_count === 0) {
        document.querySelector("#miniCartBody").classList.remove("active");
        document.querySelector("#miniCartEmpty").classList.add("active");
        document.querySelector("#miniCartContentNote").classList.add("hidden");
        document.querySelector("#miniCartFooter").classList.remove("active");
        return;
    }
    document.querySelector("#miniCartBody").classList.add("active");
    document.querySelector("#miniCartEmpty").classList.remove("active");
    document.querySelector("#miniCartContentNote").classList.remove("hidden");
    document.querySelector("#miniCartFooter").classList.add("active");


    // update subtotal
    document.querySelector("#miniCartFooterSubtotal span:last-child").textContent = price(cart.items_subtotal_price);


    // reset body container
    document.querySelectorAll(".miniCartBodyItem").forEach(element => element.remove());

    // append cart
    cart.items.forEach(function (item) {
        // subscription HTML
        function subscriptionHTML() {
            if (item.selling_plan_allocation) {
                return `<div class="miniCartBodyItemSellingPlan">${item.selling_plan_allocation.selling_plan.name}</div>`;
            }
            return "";
        }

        // variant html
        function variantHTML() {
            let HTML = "";
            if (item.variant_title !== null) {
                HTML += `<div class="miniCartBodyItemTitle">${item.variant_title}</div>`;
            }
            return HTML;
        }

        // properties HTML
        function propertiesHTML() {
            let HTML = "";
            if (item.properties) {
                HTML += Object.entries(item.properties).map(([key, value]) => {
                    if (value !== null && value !== undefined && value !== "" && key !== "_grouping") {
                        return `<div class="miniCartBodyItemTitle">${key}: ${value}</div>`;
                    }
                    return '';
                }).join('');
            }
            return HTML;
        }

        // price HTML
        function priceHTML() {
            let HTML = "";

            /****************** discount ******************/

            let comparePrice = null
            // check if selling_plan_allocation exists, if so append compare_at_price * quantity
            if (item.selling_plan_allocation) {
                comparePrice = item.selling_plan_allocation.compare_at_price * item.quantity;
            }
            // check for line item discount
            else if (item.original_line_price > item.final_line_price) {
                comparePrice = item.original_line_price;
            }
            // check for compare at price
            else if (variantIDToCompareAtPrice[item.variant_id] > item.final_price) {
                comparePrice = variantIDToCompareAtPrice[item.variant_id] * item.quantity;
            }

            // check if comparePrice exists
            if (comparePrice) {
                HTML += `<s>${price(comparePrice, false)}</s> `;
            }

            /****************** actual price ******************/

            HTML += price(item.final_line_price, false);

            return HTML;
        }

        // price HTML
        function madeToOrderHTML() {
            let HTML = ``;

            // check if variant inventory is 0
            // if so, show made to order button
            if (parseInt(variantIDToInventory[item.variant_id]) < 1) {
                HTML = `
                    <button class="miniCartBodyItemHandmade tooltip">
                        Made to Order
                        <img class="miniCartBodyItemHandmadeIcon" src="https://cdn.shopify.com/s/files/1/0038/0121/9181/files/icon-question.svg?v=1728502455&width=100" alt="Question icon">
                        <span class="tooltipBody">
                            <span class="tooltipBodyHeader">
                                <img class="tooltipBodyHeaderImg"
                                src="https://cdn.shopify.com/s/files/1/0038/0121/9181/files/icon-hand-heart.svg?v=1697655029&width=100"
                                alt="Handmade">
                                <span class="tooltipBodyHeaderTxt">Good things <em><strong>take time!</strong></em></span>
                            </span>
                            <span class="tooltipBodyTxt">
                                We work with small independent designers that handcraft each &amp; every piece with love and care. It takes 4-8 weeks to ship as it is being handmade for you. If you'd like more information prior to ordering, please don't hesitate to 
                                <a href="/pages/contact-us" title="Contact Us">contact us!</a>
                            </span>
                        </span>
                    </button>
                `;
            }

            return HTML;
        }

        document.querySelector("#miniCartBody").insertAdjacentHTML("beforeend", `
            <div class="miniCartBodyItem" key="${item.key}">
                <img class="miniCartBodyItemImage" src="${item.image}&width=200">
                <div>
                    <div class="miniCartBodyItemFlex">
                        <a class="miniCartBodyItemTitle" href="${item.url}">${item.product_title}</a>
                        <button class="miniCartBodyItemRemove">
                            <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 15 15" fill="none">
                                <path fill-rule="evenodd" clip-rule="evenodd" d="M2.79824 2.87143L0.00496205 2.86399L0 4.61623L1.74788 4.6209L2.58593 15H12.4141L13.2496 4.65181L14.995 4.65648L15 2.90416L12.2018 2.89671V0H2.79824V2.87143ZM3.54751 4.62575L4.2437 13.2477H6.60315H10.7563L11.4508 4.64696L3.54751 4.62575ZM5.07121 6.33298L5.11764 11.8659L6.91124 11.8516L6.8649 6.31861L5.07121 6.33298ZM8.08876 6.33298L8.1351 11.8659L9.92879 11.8516L9.88236 6.31861L8.08876 6.33298ZM4.59193 2.87628L10.4081 2.89186L10.4082 1.75233H4.59193V2.87628Z" fill="#A7A7A7"/>
                            </svg>                    
                        </button>
                    </div>
                    ${variantHTML()}
                    ${subscriptionHTML()}
                    ${propertiesHTML()}
                    <div class="miniCartBodyItemFlex">
                         <div class="miniCartBodyItemQuantity ${item.variant_id === freeRingSizerVariantID ? "hide" : ""}">
                            <button class="miniCartBodyItemQuantityMinus">-</button> 
                            <div class="miniCartBodyItemQuantityCount">${item.quantity}</div>
                            <button class="miniCartBodyItemQuantityPlus">+</button>
                         </div>
                         <div class="miniCartBodyItemPrice">${priceHTML()}</div>
                    </div>
                    <inventory-status class="miniCartBodyItemInventoryStatus" data-location="cart"></inventory-status>
                     ${madeToOrderHTML()}
                </div>
            </div>
        `);
    });

    // event listener for each line item
    document.querySelectorAll(`.miniCartBodyItem`).forEach(function (element) {
        // get key
        let key = element.getAttribute("key");
        let item = cart.items.find(i => i.key === key);

        // set sku/quantity via setAttribute so the DOM handles escaping (SKUs may contain ")
        // unbridaled products are not stocked in our IMS, so leave the element empty
        const inventoryStatus = element.querySelector(".miniCartBodyItemInventoryStatus");
        if (!variantIDToUnbridaled[item.variant_id] && !item.properties?._grouping) {
            inventoryStatus.setAttribute("data-vendor", item.vendor || "");
            inventoryStatus.setAttribute("data-order-quantity", item.quantity);
            inventoryStatus.setAttribute("data-sku", item.sku);
        }

        // get current quantity
        let quantity = parseInt(element.querySelector(".miniCartBodyItemQuantityCount").textContent);

        // minus
        element.querySelector(".miniCartBodyItemQuantityMinus").addEventListener("click", function () {
            if (quantity == 1) {
                element.querySelector(".miniCartBodyItemRemove").click();
            } else {
                quantity--;
                updateCartItem();
            }
        });

        // plus
        element.querySelector(".miniCartBodyItemQuantityPlus").addEventListener("click", function () {
            quantity++;
            updateCartItem();
        });

        // remove
        element.querySelector(".miniCartBodyItemRemove").addEventListener("click", function () {
            quantity = 0;
            updateCartItem();

            // fade out and remove
            element.classList.add("fade");
            setTimeout(() => {
                element.remove();
            }, 500);
        });

        // update quantity function
        async function updateCartItem() {
            // update label
            element.querySelector(`.miniCartBodyItemQuantityCount`).textContent = quantity;

            // update cart in shopify
            let response = await changeProduct({
                id: key,
                quantity: quantity
            });
            // check for error
            if (response.status === 422) {
                alert(response.message);
            } else {
                cart = response;
            }
            // update active body
            await openCart(true);
        }


    });


    // open cart
    if (document.querySelector("#miniCart:not([open])")) {
        document.querySelector("#miniCart").showModal();
    }
    document.querySelector("body").classList.add("noScroll");
}

//faq event listeners for each of the questions
document.querySelector(`#miniCartContentNoteTitle`).addEventListener("click", function () {
    if (this.parentElement.classList.contains("active")) {
        this.parentElement.classList.remove("active");
    } else {
        this.parentElement.classList.add("active");
    }
});


// checkout button loading
document.querySelector("#miniCartFooterCheckout").addEventListener("click", async function () {
    this.classList.add("loading");

    // update order note if it does not match shopify
    if (document.querySelector("#miniCartContentNoteBodyTextarea").value !== cart.note) {
        await updateCart({"note": document.querySelector("#miniCartContentNoteBodyTextarea").value});
    }

    this.classList.remove("loading");

    // update note
    await updateCart()

    window.location.href = "/checkout";
});

// close cart
function closeCart() {
    document.querySelector("#miniCart").close();
    document.querySelector("body").classList.remove("noScroll");
}

// open cart event listener
document.querySelectorAll(".openCart").forEach(function (element) {
    element.addEventListener("click", openCart);
});

//close cart event listener
document.querySelectorAll(".closeCart").forEach(function (element) {
    element.addEventListener("click", closeCart);
});
document.querySelector("#miniCart").addEventListener("click", function (e) {
    if (e.target === this) {
        closeCart();
    }
})

// open returns dialog
document.querySelector("#miniCartFooterIconsReturns").addEventListener("click", function () {
    document.querySelector("#returns").showModal();
});

// close quick add
function closeReturns() {
    document.querySelector("#returns").close();
}

//close quick add listener
document.querySelector(".closeReturns").addEventListener("click", function () {
    closeReturns();
});


/**************
 Upsells
 ***************/

// keep a reference to the upsells swiper so we can tear it down before each rebuild
let upsellsSwiper;

// the product ids the upsells were last built from, so we only re-fetch when the cart contents change
let upsellsProductIDs = null;

// resolve once the recomatic library is ready, it loads async so it may not be there on the first open
function recomaticReady() {
    return new Promise(function (resolve) {
        if (window.Recomatic && Recomatic.isInitialized) {
            resolve();
            return;
        }
        document.addEventListener("recomatic:initialized", function () {
            resolve();
        }, {once: true});
    });
}

// ask recomatic for cart recommendations, it hands back full shopify product objects
function getRecommendations(productIDs) {
    return new Promise(function (resolve) {
        Recomatic.getRecommendations({widget: "cart", product_ids: productIDs, limit: 10}, resolve);
    });
}

// price markup for a single variant, with the compare at price when it is on sale
function upsellPriceHTML(variant) {
    let compareHTML = "";
    if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        compareHTML = `<s class="miniCartContentUpsellsItemPriceCompare">${price(variant.compare_at_price, true)}</s>`;
    }
    return `${price(variant.price)}${compareHTML}`;
}

// build the upsells swiper from recomatic's recommendations for the current cart
async function renderUpsells() {
    const upsellsElement = document.querySelector("#miniCartContentUpsells");

    // the upsells are switched off in the theme editor, so the markup was never rendered
    if (!upsellsElement) {
        return;
    }

    // nothing to recommend against an empty cart
    if (cart.item_count === 0) {
        upsellsProductIDs = null;
        upsellsElement.classList.remove("active");
        return;
    }

    // skip the rebuild while the cart still holds the same products
    const productIDs = cart.items.map(item => item.product_id);
    if (productIDs.join(",") === upsellsProductIDs) {
        return;
    }
    upsellsProductIDs = productIDs.join(",");

    // wait on the library, then pull the recommendations
    await recomaticReady();
    const products = await getRecommendations(productIDs);

    // bail if the cart changed again while we were fetching, that render owns the swiper now
    if (productIDs.join(",") !== upsellsProductIDs) {
        return;
    }

    // drop anything already in the cart, recommendations can overlap with it
    const upsells = products.filter(product => !productIDs.includes(product.id));

    // tear down the previous swiper so each render rebuilds from the current upsells
    if (upsellsSwiper) {
        upsellsSwiper.destroy(true, true);
        upsellsSwiper = null;
    }

    // build the slides as one html string
    let upsellsHTML = "";
    upsells.forEach(product => {
        // we can only sell what is in stock, and only show what has an image
        const variants = product.variants.filter(variant => variant.available);
        if (variants.length === 0 || !product.featured_image) {
            return;
        }

        // anything with real options has to be picked in the options sheet, the rest adds straight from the card
        let buttonCopy = "Add To Cart";
        if (product.variants.length > 1) {
            buttonCopy = "Choose Options";
        }

        // the first available variant is the one we price and add, the alt is set on bind so titles with quotes survive
        upsellsHTML += `
            <div class="miniCartContentUpsellsItem swiper-slide" data-product-id="${product.id}">
                <a class="miniCartContentUpsellsItemLink" href="${product.url}">
                    <img class="miniCartContentUpsellsItemLinkImage" src="${product.featured_image}&width=300" alt="">
                </a>
                <a class="miniCartContentUpsellsItemTitle" href="${product.url}">${product.title}</a>
                <div class="miniCartContentUpsellsItemPrice">${upsellPriceHTML(variants[0], true)}</div>
                <button class="miniCartContentUpsellsItemAdd" data-variant-id="${variants[0].id}">${buttonCopy}</button>
            </div>
        `;
    });

    // hide the whole upsells section when there is nothing left to show
    if (upsellsHTML === "") {
        upsellsElement.classList.remove("active");
        return;
    }
    upsellsElement.classList.add("active");
    upsellsElement.querySelector("#miniCartContentUpsellsSwiper .swiper-wrapper").innerHTML = upsellsHTML;

    // init the carousel now that the slides are in place
    upsellsSwiper = new Swiper("#miniCartContentUpsellsSwiper", {
        slidesPerView: 3,
        spaceBetween: 12,
        pagination: {
            el: "#miniCartContentUpsellsPagination",
            clickable: true,
        },
    });

    // bind each freshly rendered slide
    upsellsElement.querySelectorAll(".miniCartContentUpsellsItem").forEach(element => {
        const product = upsells.find(upsell => upsell.id === Number(element.dataset.productId));
        const button = element.querySelector(".miniCartContentUpsellsItemAdd");

        // set the alt through the dom so product titles containing quotes cannot break the markup
        element.querySelector(".miniCartContentUpsellsItemLinkImage").alt = product.title;

        // hand anything with options off to the sheet, otherwise add the only variant there is
        button.addEventListener("click", async function () {
            // report the click back to recomatic so their attribution still works
            Recomatic.triggerClick(product.handle, "cart");

            if (product.variants.length > 1) {
                await openUpsellOptions(product);
                return;
            }

            document.querySelector("#miniCartContent").classList.add("loading");

            // ims has the final say on stock, adding a sold out variant would only get stripped back out
            const variant = product.variants[0];
            const status = await getInventoryStatus(variant.sku);
            if (status.error || status.sold_out) {
                document.querySelector("#miniCartContent").classList.remove("loading");
                button.textContent = "Sold Out";
                button.disabled = true;
                return;
            }

            await addProduct({
                items: [{
                    id: variant.id,
                    quantity: 1,
                }]
            });
            await openCart();
        });
    });
}


/**************
 Upsell Options
 ***************/

// the upsell the options sheet is currently showing
let upsellOptionsProduct = null;

// the variant the current selection resolves to, so a slow ims check can tell it is stale
let upsellOptionsVariant = null;

// the options the sheet is offering, as [{name, values: [{title, id}]}]
let upsellOptionsList = [];

// the picked option titles, so a lookup or ims check that comes back late can tell it is stale
let upsellOptionsSelection = null;

// show the picked variant's image, falling back to the product's when there is no variant or it has none of its own
// the product carries a plain image url while a variant carries an image object
function setUpsellOptionsImage(variant) {
    let source = upsellOptionsProduct.featured_image;
    if (variant && variant.featured_image) {
        source = variant.featured_image.src;
    }
    document.querySelector("#miniCartUpsellOptionsBodyImage").src = `${source}&width=400`;
}

// the inventory status component caches the last sku it fetched, so swap in a fresh one rather than reuse it
function resetUpsellOptionsInventoryStatus() {
    document.querySelector("#miniCartUpsellOptionsBodyInfoInventoryStatus").outerHTML = `<inventory-status id="miniCartUpsellOptionsBodyInfoInventoryStatus" data-location="cart"></inventory-status>`;
}

// the options to offer, as [{name, values: [{title, id}]}], dropping values shopify has nothing available for
// past 250 variants the product json is truncated, so liquid hands us the full option list and the value ids we need to look a variant up
async function getUpsellOptionsList(product) {
    if (product.variants.length >= 250) {
        const response = await fetch(`/products/${product.handle}?view=option-values`).then(response => response.json());
        return response.options.map(option => ({
            name: option.name,
            values: option.values.filter(value => value.available),
        }));
    }

    // under the cap the variants carry every value we need
    return product.options.map((option, index) => {
        const titles = [...new Set(product.variants.filter(variant => variant.available).map(variant => variant.options[index]))];
        return {
            name: option.name ?? option,
            values: titles.map(title => ({title: title, id: null})),
        };
    });
}

// resolve the picked options to a variant, mirroring how the pdp handles the 250 variant cap
async function getUpsellOptionsVariant(product, selectedValues) {
    const selectedTitles = selectedValues.map(value => value.title);

    // over the cap the variant may not be in the payload at all, so let the product page resolve it
    if (product.variants.length >= 250) {
        const optionIDs = selectedValues.map(value => value.id);
        const response = await fetch(`/products/${product.handle}?view=active-variant&option_values=${optionIDs.join(",")}`)
            .then(response => response.json());
        const activeVariant = response.active_variant;

        // liquid falls back to the first available variant when the combination does not exist, so make sure it is ours
        if (!activeVariant || JSON.stringify(activeVariant.options) !== JSON.stringify(selectedTitles)) {
            return null;
        }
        return activeVariant;
    }

    // under the cap match against the variant list
    return product.variants.find(variant => JSON.stringify(variant.options) === JSON.stringify(selectedTitles));
}

// open the sheet for an upsell with options, one select per option name
async function openUpsellOptions(product) {
    upsellOptionsProduct = product;
    upsellOptionsVariant = null;
    upsellOptionsList = [];

    const dialogElement = document.querySelector("#miniCartUpsellOptions");

    // fill the product summary, the alt and title go through the dom so quotes in titles cannot break anything
    setUpsellOptionsImage(null);
    dialogElement.querySelector("#miniCartUpsellOptionsBodyImage").alt = product.title;
    dialogElement.querySelector("#miniCartUpsellOptionsBodyInfoTitle").textContent = product.title;
    dialogElement.querySelector("#miniCartUpsellOptionsBodyInfoPrice").innerHTML = "";
    dialogElement.querySelector("#miniCartUpsellOptionsSelects").innerHTML = "";
    resetUpsellOptionsInventoryStatus();

    // the css animation fires off the open attribute, so showing the dialog is all the slide up needs
    dialogElement.showModal();

    upsellOptionsList = await getUpsellOptionsList(product);

    // bail if they closed the sheet or opened another one while we were loading
    if (upsellOptionsProduct !== product) {
        return;
    }

    // build a select per option
    let selectsHTML = "";
    upsellOptionsList.forEach((option, index) => {
        // the option carries its index rather than its title, a title like 18" would break out of the attribute
        let optionsHTML = `<option value="" selected hidden>Please select an option</option>`;
        option.values.forEach((value, valueIndex) => {
            optionsHTML += `<option value="${valueIndex}">${value.title}</option>`;
        });

        selectsHTML += `
            <div class="miniCartUpsellOptionsSelectsItem">
                <label class="miniCartUpsellOptionsSelectsItemLabel" for="miniCartUpsellOptionsSelectsItemSelect${index}">${option.name}</label>
                <select class="miniCartUpsellOptionsSelectsItemSelect" id="miniCartUpsellOptionsSelectsItemSelect${index}">
                    <button>
                        <selectedcontent></selectedcontent>
                    </button>
                    ${optionsHTML}
                </select>
            </div>
        `;
    });
    dialogElement.querySelector("#miniCartUpsellOptionsSelects").innerHTML = selectsHTML;

    // re-check the variant on every change
    dialogElement.querySelectorAll(".miniCartUpsellOptionsSelectsItemSelect").forEach(select => {
        select.addEventListener("change", updateUpsellOptions);
    });

    updateUpsellOptions();
}

// resolve the picked options to a variant, then price it and check it against ims
async function updateUpsellOptions() {
    const dialogElement = document.querySelector("#miniCartUpsellOptions");
    const addElement = dialogElement.querySelector("#miniCartUpsellOptionsAdd");
    const priceElement = dialogElement.querySelector("#miniCartUpsellOptionsBodyInfoPrice");

    // read the picked values back out in option order, that is the order variant.options uses
    const selectedValues = [];
    dialogElement.querySelectorAll(".miniCartUpsellOptionsSelectsItemSelect").forEach((select, index) => {
        selectedValues.push(upsellOptionsList[index].values[select.value] ?? null);
    });

    // nudge them through the options they have not picked yet
    const missingIndex = selectedValues.indexOf(null);
    if (missingIndex !== -1) {
        upsellOptionsSelection = null;
        upsellOptionsVariant = null;
        priceElement.innerHTML = "";
        setUpsellOptionsImage(null);
        resetUpsellOptionsInventoryStatus();
        addElement.classList.remove("loading");
        addElement.textContent = `Select ${upsellOptionsList[missingIndex].name}`;
        addElement.disabled = true;
        return;
    }

    // stamp the selection so the lookup and the ims check can tell they went stale
    const selection = JSON.stringify(selectedValues.map(value => value.title));
    upsellOptionsSelection = selection;
    upsellOptionsVariant = null;

    // the lookup can hit the network, so re-check the selection before trusting the answer
    const variant = await getUpsellOptionsVariant(upsellOptionsProduct, selectedValues);
    if (upsellOptionsSelection !== selection) {
        return;
    }
    upsellOptionsVariant = variant;

    // no such combination, or shopify has nothing to sell for it
    if (!variant || !variant.available) {
        priceElement.innerHTML = "";
        setUpsellOptionsImage(null);
        resetUpsellOptionsInventoryStatus();
        addElement.classList.remove("loading");
        addElement.textContent = "Sold Out";
        addElement.disabled = true;
        return;
    }

    // price it, swap to its image, and let the inventory status component show the lead time
    priceElement.innerHTML = upsellPriceHTML(variant);
    setUpsellOptionsImage(variant);
    const inventoryStatusElement = dialogElement.querySelector("#miniCartUpsellOptionsBodyInfoInventoryStatus");
    inventoryStatusElement.setAttribute("data-vendor", upsellOptionsProduct.vendor || "");
    inventoryStatusElement.setAttribute("data-order-quantity", "1");
    inventoryStatusElement.setAttribute("data-sku", variant.sku);

    // ims is the source of truth for stock, same check the pdp makes
    addElement.classList.add("loading");
    addElement.disabled = true;
    const status = await getInventoryStatus(variant.sku);

    // bail if they picked something else while we were checking
    if (upsellOptionsSelection !== selection) {
        return;
    }
    addElement.classList.remove("loading");

    if (status.error || status.sold_out) {
        addElement.textContent = "Sold Out";
        addElement.disabled = true;
        return;
    }
    addElement.textContent = "Add To Cart";
    addElement.disabled = false;
}

// close the sheet
function closeUpsellOptions() {
    document.querySelector("#miniCartUpsellOptions").close();
}

// add the picked variant, then let the cart re-render filter this upsell out
document.querySelector("#miniCartUpsellOptionsAdd").addEventListener("click", async function () {
    this.classList.add("loading");

    const response = await addProduct({
        items: [{
            id: upsellOptionsVariant.id,
            quantity: 1,
        }]
    });
    this.classList.remove("loading");

    // shopify rejects anything it has no stock for, keep the sheet open so they can pick something else
    if (response.status === 422) {
        alert(response.message);
        return;
    }

    closeUpsellOptions();
    await openCart();
});

// close listeners
document.querySelector(".closeUpsellOptions").addEventListener("click", closeUpsellOptions);
document.querySelector("#miniCartUpsellOptions").addEventListener("click", function (e) {
    if (e.target === this) {
        closeUpsellOptions();
    }
});


// check is coming from the cart
if (document.referrer.includes("/cart")) {
    openCart();
}